module.exports = {
	"notification.message": "Wix.com gebruikt cookies om u de best mogelijke ervaring te geven.",
	"notification.got.it": "OK",
	"notification.more.info": "Meer informatie",
	"notification.got.it.arrow": "arrow icon"
};


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_nl.json
// module id = 46
// module chunks = 0